import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Import Firestore
import { getStorage } from "firebase/storage"; // Import Storage
import { getFunctions } from "firebase/functions";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
// };

const firebaseConfig = {
  apiKey: "AIzaSyBh1_saInyvZCu-NpA2ncB-H-Jt3O8oQZk",
  authDomain: "businesscardsbw.firebaseapp.com",
  projectId: "businesscardsbw",
  storageBucket: "businesscardsbw.appspot.com",
  messagingSenderId: "477316693107",
  appId: "1:477316693107:web:97de774116eb5574c83e06",
};

// const missingFirebaseConfig = Object.entries(firebaseConfig)
//   .filter(([, value]) => !value)
//   .map(([key]) => key);

// if (missingFirebaseConfig.length > 0) {
//   throw new Error(
//     `Missing Firebase environment variables for: ${missingFirebaseConfig.join(
//       ", "
//     )}`
//   );
// }

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app); // Initialize Firestore
const storage = getStorage(app); // Initialize Storage
const functions = getFunctions(app); // Initialize functions

export { auth, db, storage, functions }; // Export the services
